const pat = /^((http|https|ftp):\/\/)/;

export default {
  methods: {
    goTo(url, type = '_blank') {
      return window.open(`${pat.test(url) ? '' : 'http://' }${url}`, type);
    },
  },
};
